import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/art/family_cycling.webp'


const _withScopeId = n => (_pushScopeId("data-v-4bc8bedc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {"padding":"1rem"}
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "Radwegering Wuppertal"),
    /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, " Ein nachhaltiges Konzept für die Bundesgartenschau 2031 ")
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "bottom-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    id: "bottom-img"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_menu = _resolveComponent("ion-menu")!

  return (_openBlock(), _createBlock(_component_ion_menu, {
    "content-id": "mainContent",
    "menu-id": "mobileMenu",
    side: "start"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(_component_ion_list, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.NavigationList, (nav) => {
              return (_openBlock(), _createBlock(_component_ion_item, {
                onClick: ($event: any) => {
            _ctx.$router.push(nav.url);
            _ctx.closeMenu()
          },
                class: "clickable ion-activatable",
                key: nav.url
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    icon: nav.icon,
                    slot: "start"
                  }, null, 8, ["icon"]),
                  _createTextVNode(" " + _toDisplayString(nav.label), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }),
        _hoisted_2
      ])
    ]),
    _: 1
  }))
}